import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { GitlabClient } from '../httpClients/GitlabClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useLoginGitlabRetry = () => {
  const spawnToasts = spawn('toasts.gitlab.login-retry');

  return useMutation({
    mutationKey: [MUTATION_KEYS.LOGIN_GITLAB_RETRY],
    mutationFn: async () => {
      return await GitlabClient.loginRetry();
    },
    onError: (err: any) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
